module.exports = {"confirmDeleteOrder":"Confirm to delete order.","fillInreason":"Please fill in your reason. "}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/modal/ENG.json
// module id = 1333
// module chunks = 121